import { render, staticRenderFns } from "./CompraLogisticaForm.vue?vue&type=template&id=78c6a304&"
import script from "./CompraLogisticaForm.vue?vue&type=script&lang=js&"
export * from "./CompraLogisticaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports